"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_1 = require("vue");
var uuid_1 = require("uuid");
var state = (0, vue_1.reactive)({
    notifications: [],
});
var actions = {
    removeNotification: function (id) {
        state.notifications = state.notifications.filter(function (notification) { return notification.id !== id; });
    },
    dispatchNotification: function (_a) {
        var title = _a.title, content = _a.content, type = _a.type, _b = _a.autoClose, autoClose = _b === void 0 ? true : _b, _c = _a.duration, duration = _c === void 0 ? 3000 : _c;
        var id = (0, uuid_1.v4)();
        var notifications = __spreadArray([{
                id: id,
                title: title,
                content: content,
                type: type,
            }], state.notifications, true);
        state.notifications = notifications;
        if (autoClose) {
            setTimeout(function () {
                actions.removeNotification(id);
            }, duration);
        }
    }
};
var getters = {
    getNotifications: function () {
        return __spreadArray([], state.notifications, true).slice(0, 4);
    },
    getNotificationsCount: function () {
        return state.notifications.length;
    }
};
exports.default = {
    state: (0, vue_1.readonly)(state),
    actions: actions,
    getters: getters,
};
